import { Component, AfterViewInit } from "@angular/core";
import { AppComponent } from './app.component';
import * as Sentry from "@sentry/angular";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent implements AfterViewInit {
  constructor(public app: AppComponent) { }

  anneeCourante: number = new Date().getFullYear();

  ngAfterViewInit(): void {
    const feedback = Sentry.getFeedback();
    feedback?.attachTo(document.querySelector("#button-feedback"), {
      formTitle: "Signaler un bug",
    });
  }

  get version(): string {
    return environment?.app?.version || 'v1.0.0';
  }

  openVersionDialog() {
    window.open('https://changelog.hamel.construction/#SIHC' + this.version, '_blank');
  }
}
